import { type Interpolation, type Theme } from '@emotion/react';
import { type Theme as MuiTheme } from '@mui/material';
import { Property } from 'csstype';

import typography from './typography';

export default (palette: MuiTheme['palette']): Interpolation<Theme> => ({
  '.p-treeselect-panel': {
    // Dirty fix needed due to interference betweel overlay layers of MUI and Primereact
    zIndex: '10000 !important',
    position: 'fixed !important' as Property.Position,
    display: 'block !important'
  },
  '.p-treeselect': {
    borderColor: palette.grey[600]
  },
  '.p-treeselect-panel .p-checkbox.p-highlight .p-checkbox-box': {
    background: palette.primary.main,
    borderColor: palette.primary.main
  },
  '.p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight': {
    background: palette.primary[200]
  },
  '.p-tree .p-tree-container .p-treenode .p-treenode-content .p-checkbox.p-indeterminate .p-checkbox-icon': {
    color: '#fff'
  },
  '.p-tree .p-tree-container .p-treenode .p-treenode-content.p-treenode-selectable:not(.p-highlight):hover': {
    background: palette.primary[100]
  },
  '.p-tree .p-tree-container .p-treenode:focus > .p-treenode-content': {
    boxShadow: 'none'
  },
  '.p-treeselect:not(.p-disabled).p-focus': {
    boxShadow: 'none',
    borderColor: palette.grey[600]
  },
  '.p-treeselect-header': {
    display: 'none'
  },
  '.p-tree.p-component.p-tree-selectable': {
    padding: 8
  },
  '.p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler': {
    order: 2
  },
  '.p-tree .p-tree-container .p-treenode .p-treenode-content .p-checkbox': {
    order: 1,
    marginInlineStart: 8
  },
  '.p-tree .p-tree-container .p-treenode .p-treenode-content .p-treenode-label': {
    order: 3
  },
  '.p-treenode-leaf > .p-treenode-content .p-tree-toggler': {
    display: 'none'
  },
  '.p-treenode-leaf .p-treenode-content.p-treenode-selectable': {
    paddingTop: 6,
    paddingBottom: 6
  },
  '.p-tree-empty-message .p-treenode-content': {
    fontSize: typography.body2!.fontSize!,
    color: palette.grey[700]
  },
  '.p-treeselect .p-treeselect-label:not(.p-placeholder)': {
    padding: 4
  }
});
